import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_METRICS = [
  { value: "15+", label: "Years of expertise" },
  { value: "120+", label: "Products & SKUs" },
  { value: "50k+", label: "Sq.ft. capacity" },
  { value: "20+", label: "States served" },
  { value: "6", label: "Certifications" },
];

export default function TrustMetrics() {
  const [metrics, setMetrics] = useState(DEFAULT_METRICS);
  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      if (Array.isArray(data.stats) && data.stats.length) setMetrics(data.stats);
    }).catch(() => {});
  }, []);

  return (
    <section className="border-y border-[#e7e0d6] bg-[#f2ece4]" data-testid="trust-metrics">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-8 px-5 py-12 md:grid-cols-5 md:px-8">
        {metrics.map((m, i) => (
          <motion.div key={m.label + i}
            initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className="text-center" data-testid={`metric-${i}`}>
            <div className="font-serif text-4xl text-[#202124] md:text-5xl">{m.value}</div>
            <div className="mt-1 text-sm font-medium text-[#6b6a65]">{m.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
